import { auth } from "./Firebase";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  sendPasswordResetEmail,
  updatePassword,
  sendEmailVerification,
} from "firebase/auth";
import { setAuthToken } from '../services/api';


export const doCreateUserWithEmailAndPassword = async (email, password) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    // Get the Firebase ID token
    const token = await userCredential.user.getIdToken();
    setAuthToken(token);
    return userCredential;
  } catch (error) {
    throw error;
  }
};

export const doSignInWithEmailAndPassword = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    // Get the Firebase ID token
    const token = await userCredential.user.getIdToken();
    setAuthToken(token);
    return userCredential;
  } catch (error) {
    throw error;
  }
};

export const doSignOut = async () => {
  try {
    await signOut(auth);
    setAuthToken(null);
  } catch (error) {
    throw error;
  }
};


export const doPasswordReset = (email) => {
  return sendPasswordResetEmail(auth, email);
};

export const doPasswordChange = (password) => {
  return updatePassword(auth.currentUser, password);
};

export const doSendEmailVerification = () => {
  return sendEmailVerification(auth.currentUser, {
    url: `${window.location.origin}/home`,
  });
};
// Listen for token changes and update localStorage
auth.onIdTokenChanged(async (user) => {
  if (user) {
    const token = await user.getIdToken();
    setAuthToken(token);
  } else {
    setAuthToken(null);
  }
});
